// extracted by mini-css-extract-plugin
export default {"mainSection":"Home_mainSection__U6bPp"};